/* eslint-disable max-statements */
import axios from 'axios';
import React, { useRef, useState } from 'react';
import { useInfiniteQuery } from 'react-query';
import { globalEnv } from '../../../config/baseConfig';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import LazyImage from '../../Utils/Components/imageComponent';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

export const UserListModalContent = ({
	topicId,
	isActiveUsers = false
}: {
	topicId: string;
	isActiveUsers: boolean;
}) => {
	const [isPaused, setPause] = useState(false);
	const [userList, setUserList] = useState<any[]>([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [page, setPage] = useState(1);
	const [totalNumberOfUsers, setTotalNumberOfUsers] = useState(0);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const fetchUsers = async () => {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};

		let url = 'get-users';
		if (isActiveUsers) url = 'get-active-users';

		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/admin/topic/${topicId}/${url}?page=${page}&search=${searchTerm}`,
			config
		);
		let userListCopy = [];
		if (page > 1) userListCopy = userList.slice();

		data.users.map((item: any) => userListCopy.push(item));

		setUserList(userListCopy);
		setTotalNumberOfUsers(data.meta.total);
		return {
			data
		};
	};

	const { isFetching, refetch } = useInfiniteQuery([page], fetchUsers, {
		keepPreviousData: false,
		cacheTime: 0,
		refetchOnWindowFocus: false
	});

	const listInnerRef = useRef<null>(null);

	const onScroll = () => {
		if (userList.length < totalNumberOfUsers && userList.length > 0)
			if (!isFetching) {
				if (listInnerRef.current) {
					const { scrollTop, scrollHeight, clientHeight } =
						listInnerRef.current;
					if (scrollTop + clientHeight >= scrollHeight - 600) {
						if (!isPaused) {
							setPage(page + 1);
							setPause(true);
						}
					} else undoPause();
				}
			}
	};

	const undoPause = () => {
		setTimeout(() => {
			setPause(false);
		}, 1000);
	};

	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
                 w-4/6 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
		>
			<div
				className="relative min-w-300 flex items-center justify-start
                    bg-gray-400 dark:bg-gray-600 text-gray-500 h-9 ml-0 mr-0
                      rounded-md shadow-md transition duration-500 ease-in-out"
			>
				<input
					className="w-full font-sans font-semibold bg-transparent outline-none mx-2 my-2
                        text-gray-800 dark:text-white placeholder-gray-500 pl-1 rounded"
					type="text"
					placeholder={'Find users'}
					onChange={(e) => {
						setSearchTerm(e.target.value);
					}}
					value={searchTerm}
				/>
				<FaSearch
					size="18"
					className="text-purple-600 my-auto cursor-pointer mx-2"
					onClick={() => {
						console.log(searchTerm);
						setUserList([]);
						setTotalNumberOfUsers(0);
						setPage(1);
						refetch();
					}}
				/>
			</div>

			<section
				className="relative bg-white w-full max-h-screen overflow-y-auto h-screen
                                dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
				onScroll={() => onScroll()}
				ref={listInnerRef}
			>
				<div className="mx-auto max-w-lg w-10/12 my-10">
					{userList.map((item: any) => (
						<UserElement
							id={item._id}
							username={item.username}
							createdAt={item.createdAt}
							photo={item.photo}
						/>
					))}
				</div>
			</section>
		</div>
	);
};

function UserElement({
	id,
	username,
	createdAt,
	photo
}: {
	id: string;
	username: string;
	createdAt: string;
	photo: string;
}) {
	const navigate = useNavigate();
	return (
		<div className="relative group bg-gray-300 dark:bg-gray-700 mt-2 w-full h-fit flex flex-col items-start rounded-lg overflow-hidden ">
			<div
				className="w-full h-full flex items-start align-middle px-4 py-3 dark:hover:bg-gray-600 hover:bg-gray-400 cursor-pointer"
				onClick={() => navigate(`../user/${id}`)}
			>
				<div className="mr-2">
					<LazyImage
						photo={
							photo != null
								? photo
								: `https://api.dicebear.com/7.x/bottts/svg?seed=${username}`
						}
						dimesnions={'25'}
						loaderDimesnions={23}
					/>
				</div>
				<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white ">
					{username}
				</div>
				<div className="font-medium text-sm ml-auto mt-0.5 text-gray-800 dark:text-white ">
					{moment(createdAt).format('MM/DD/YYYY - HH:mm')}
				</div>
			</div>
		</div>
	);
}
